import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmReportsSatisfactionIssueRoute: InvariantJiraRoute = {
	name: 'csm-reports-satisfaction-time-scale-issue',
	path: '/jira/customer-service-management/projects/:projectKey/reports/all-rating/timescale/:timescaleId/:issueKey',
	exact: true,
};
